import { useState } from 'react'
import moment from "moment"
import { Modal } from "react-bootstrap"
import { useNavigate } from "react-router-dom"
import config from "../../config/config"
import { IUserDetails } from "../../interfaces/authentication"
import { IOption } from "../../interfaces/family"
import { IStory } from "../../interfaces/story"
import { dateFormat } from "../../_helper/enum/enum"
import { getStoryDate } from "../../_helper/getStoryDate"
import { useTranslation } from "react-i18next"
import { JSX } from 'react/jsx-runtime'

export interface IProps {
    story: IStory,
    text?:() => JSX.Element,
    clear: () => void,
    show: boolean
}

function Infocard(props: IProps) {

    const [copied, setCopied] = useState<boolean>(false);

    const navigate = useNavigate();

    const { t } = useTranslation();

    const url = props.story.privateId ? window.location.origin + "/story/" +  encodeURIComponent(props.story.privateId) : "";
    
    function copyHelper() {
        setCopied(true);
        setTimeout(() => {
            setCopied(false);
        }, config.modalCloseTimeout)
    }    
    
    return (
        <Modal className="tooltip-container infocard-container" show={props.show} onHide={props.clear}>
            <Modal.Header className="tooltip-header infocard-header" closeButton>
                <Modal.Title className="title">{t("Info Card")}</Modal.Title>
            </Modal.Header>
            <Modal.Body className="tooltip-content infocard-content">
                <div className="body">
                    <div className="infocard-text-section">
                        {props.story.date && props.story.createdAt && (
                            <div>
                                <p>{t("Story date")}</p>
                                <p>
                                    {getStoryDate(props.story.date.startDate)} {props.story.date.endDate && <span> - {getStoryDate(props.story.date.endDate)}</span>}
                                </p>
                            </div>
                        )}
                        {props.story.createdAt && (
                            <div>
                                <p>{t("Published date")}</p>
                                <p>
                                    {moment(props.story.createdAt).format(dateFormat.SHORT)}
                                </p>
                            </div>
                        )}
                        {props.story.storyTags.length ? ( 
                            <div className="story-tags">                                 
                                <p>{t("Story Tag(s)")}</p>
                                <p>
                                {props.story.storyTags.map(x => {
                                    return(
                                        <a className="underlined-link-button" onClick={() => navigate({pathname: '/dashboard/stories/2'}, {state: { filters: { story: {storyTags: [(config.storyTags.find(data => data._id === x) as IOption)]} }} })}>
                                            {t((config.storyTags.find(data => data._id === x) as IOption).text)}
                                        </a>
                                    )                                  
                                })}
                                </p>
                            </div>                                 
                        ) : null}
                        <div>                                       
                            <p>{t("Featured Profile")}</p>
                            <p>
                                <a className="underlined-link-button" href={`/dashboard/profile/${(props.story.featured as IUserDetails)._id}/1`}>
                                    {`${(props.story.featured as IUserDetails).firstname} ${(props.story.featured as IUserDetails).lastname}`}
                                </a>
                            </p>     
                        </div>
                        {(props.story.author as IUserDetails)._id !== (props.story.featured as IUserDetails)._id ? (                    
                        <div>
                            <p>{t("Author")}</p>
                            <p>
                                <a className="underlined-link-button" href={`/dashboard/profile/${(props.story.author as IUserDetails)._id}/1`}>
                                {`${(props.story.author as IUserDetails).firstname} ${(props.story.author as IUserDetails).lastname}`}
                                </a>
                            </p>
                        </div>
                        ) : null}                    
                            {props.story.coAuthors.length ? (
                                <div>                            
                                    <p>{t("Co-author(s)")}</p>
                                    <p>
                                        {(props.story.coAuthors as IUserDetails[]).map((coauthor, index) => {
                                            return( 
                                                <div>
                                                    <a className="underlined-link-button" href={`/dashboard/profile/${(coauthor as IUserDetails)._id}/1`}>
                                                        <span>{` ${coauthor.firstname} ${coauthor.lastname}`}</span>
                                                    </a>
                                                    <span>{`${index === props.story.coAuthors.length - 1 ? "" : ", "}`}</span>
                                                </div>
                                            )                                  
                                        })}
                                    </p>
                                </div>                                
                            ) : null}
                            {props.story.participants.length ? (
                            <div>                                                               
                                    <p>{t("Participant(s)")}</p>
                                    <p>
                                        {(props.story.participants as IUserDetails[]).map((participant, index) => {
                                            return (
                                                <div>
                                                    <a className="underlined-link-button" href={`/dashboard/profile/${(participant as IUserDetails)._id}/1`}>                                        
                                                        <span>{` ${participant.firstname} ${participant.lastname}`}</span>
                                                    </a>
                                                    <span>{`${index === props.story.participants.length - 1 ? "" : ", "}`}</span>
                                                </div>  
                                            )                             
                                        })}
                                    </p>
                            </div>
                            ) : null}
                        {props.story.privateId ?
                            <div>
                                <p>{t("Private sharing link")}</p>
                                {copied ? 
                                    <p className="copy">{t("Copied!")}</p> 
                                    : 
                                    <p className="underlined-link-button" onClick={() => {navigator.clipboard.writeText(url); copyHelper()}}>{t("Click to copy")}</p>}
                                
                            </div>
                            : 
                            <div>
                                <p>{t("Private sharing link")}</p>
                                <p>{t("Sharing disabled by author")}</p>
                            </div>
                        }
                    </div>
                        {props.story.sLocation.lat && props.story.sLocation.lng ?
                        <div className="displayed-google-map">
                            <iframe 
                                title="google-maps" 
                                width="100%"
                                height="350"
                                loading="lazy"
                                src={`https://maps.google.com/maps?q=${props.story.sLocation.lat},${props.story.sLocation.lng}&z=15&output=embed`} />
                        </div>
                        : null}
                </div>
            </Modal.Body>
        </Modal>
    )
}

export default Infocard
